import React, { useEffect, useState } from "react";
import Header from "../components/header";
import { useLocation } from "react-router-dom";
import { Form, Modal, Table } from "react-bootstrap";
import { RiDeleteBin2Line } from "react-icons/ri";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

import "./pstyle.css";
import GlobalURL from "../baseUrl";
import { BsArrowsFullscreen } from "react-icons/bs";
import { tokenVerification } from "../commonFunc/verification";
import { IoIosSearch } from "react-icons/io";
import { LuCircleChevronLeft } from "react-icons/lu";

import { useSelector } from "react-redux";
import translations from "../locals/translation";

import { MdReport } from "react-icons/md";

import { Tooltip as ReactTooltip } from "react-tooltip";

function TruckDetails() {
  const navigate = useNavigate();
  const location = useLocation();

  const language = useSelector((state) => state.language.value);
  const t = (key) => {
    if (translations[language]) {
      const translation = translations[language][key];
      return translation !== undefined ? translation : key;
    } else {
      return key;
    }
  };

  const [truckData, setTruckData] = useState([]);
  const [idDel, setidDel] = useState("");
  const [ueload, setUeload] = useState(false);
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showReas, setShowReas] = useState(false);
  const handleClose = () => setShow(false);
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(true);
  const [searchInput, setSearchInput] = useState("");

  const [originalData, setOriginalData] = useState([]);

  useEffect(() => {
    getAllVendors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ueload]);

  useEffect(() => {
    if (location.state == null || location.state === undefined) {
      navigate("/dashboard");
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (location.state == null || location.state === undefined) {
    navigate("/dashboard");
    return;
  }

  const truckDetails = location.state.td.vendor_id;
  const vendor = location.state.td.first_name;

  async function deleteTruck(id) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: t("Are you sure?"),
        text: t(
          "Warning: This action will permanently delete the truck and its associated details. Are you sure you want to proceed? This process cannot be undone."
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: t("Delete"),
        cancelButtonText: t("Cancel!"),
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          setSearchInput("");
          setShowPass(true);
          setPassword("");
          setShowPass(true);
        }
      });
  }
  async function suspendTruck(id) {
    setidDel(id);
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: t("Are you sure?"),
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: t("Yes"),
        cancelButtonText: "No",
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          setShowReas(true);
        }
      });
  }
  const suspendContinue = async () => {
    const token = localStorage.getItem("token");
    const Newtoken = await tokenVerification(token);
    if (!reason) {
      alert("Justification Required");
      return;
    }
    setShowReas(false);
    const url = `${GlobalURL}/api/dev/admin/suspendTruck`;

    const headers = {
      "Content-Type": "application/json",
      lang_id: language,
      token: `${Newtoken}`,
      "ngrok-skip-browser-warning": "69420",
    };

    const requestData = {
      truck_id: idDel,
      message: reason,
    };

    try {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false, // Hide the "OK" button
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      const response = await fetch(url, {
        method: "POST", // Use the appropriate HTTP method (GET, POST, etc.)
        mode: "cors",
        headers,
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      setLoading(false);

      if (data.status_code === 200) {
        Swal.close();
        Swal.fire({ text: data.message, icon: "success" });
      } else if (data.status_code === 404) {
        Swal.close();
        Swal.fire(data.message);
      } else if (data.status_code === 400) {
        Swal.close();
        Swal.fire(data.message);
      } else if (data.status_code === 401) {
        Swal.close();
        Swal.fire(data.message);
      }

      setReason("");
      setUeload(!ueload);
      Swal.close();
    } catch (error) {
      console.error("Error:", error.message);
      Swal.close();
    }
  };
  async function unsuspendTruck(id) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: t("Are you sure?"),
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: t("Yes"),
        cancelButtonText: "No",
        reverseButtons: true,
      })
      .then(async (result) => {
        const token = localStorage.getItem("token");
        const Newtoken = await tokenVerification(token);
        if (result.isConfirmed) {
          const url = `${GlobalURL}/api/dev/admin/unsuspendTruck`;
          const headers = {
            "Content-Type": "application/json",
            lang_id: language,
            token: `${Newtoken}`,
            "ngrok-skip-browser-warning": "69420",
          };

          const requestData = {
            truck_id: id,
          };

          try {
            Swal.fire({
              title: "Loading...",
              allowOutsideClick: false,
              showConfirmButton: false, // Hide the "OK" button
              onBeforeOpen: () => {
                Swal.showLoading();
              },
            });
            const response = await fetch(url, {
              method: "POST", // Use the appropriate HTTP method (GET, POST, etc.)
              headers: headers,
              body: JSON.stringify(requestData),
            });

            const data = await response.json();

            if (data.status_code === 200) {
              Swal.close();
              Swal.fire(data.message);
            } else if (data.status_code === 404) {
              Swal.close();
              Swal.fire(data.message);
            } else if (data.status_code === 400) {
              Swal.close();
              Swal.fire(data.message);
            } else if (data.status_code === 401) {
              Swal.close();
              Swal.fire(data.message);
            } else {
              Swal.close();
              Swal.fire(t("Server Error"));
            }

            swalWithBootstrapButtons.fire({
              title: data.message,
              text: "",
              icon: "success",
            });
            setUeload(!ueload);
          } catch (error) {
            console.error("Error:", error.message);
          }
        }
      });
  }
  async function activateTruck(id) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: t("Are you sure?"),
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: t("Yes"),
        cancelButtonText: "No",
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          const token = localStorage.getItem("token");
          const Newtoken = await tokenVerification(token);
          const url = `${GlobalURL}/api/dev/admin/activateTruck`;
          const headers = {
            "Content-Type": "application/json",
            lang_id: language,
            token: `${Newtoken}`,
            "ngrok-skip-browser-warning": "69420",
          };

          const requestData = {
            truck_id: id,
          };

          try {
            Swal.fire({
              title: "Loading...",
              allowOutsideClick: false,
              showConfirmButton: false, // Hide the "OK" button
              onBeforeOpen: () => {
                Swal.showLoading();
              },
            });
            const response = await fetch(url, {
              method: "POST", // Use the appropriate HTTP method (GET, POST, etc.)
              headers: headers,
              body: JSON.stringify(requestData),
            });

            const data = await response.json();

            if (data.status_code === 200) {
              Swal.close();
              Swal.fire(data.message);
            } else if (data.status_code === 404) {
              Swal.close();
              Swal.fire(data.message);
              return;
            } else if (data.status_code === 400) {
              Swal.close();
              Swal.fire(data.message);
              return;
            } else if (data.status_code === 401) {
              Swal.close();
              Swal.fire(data.message);
              return;
            }

            swalWithBootstrapButtons.fire({
              title: data.message,
              text: "",
              icon: "success",
            });

            setUeload(!ueload);
          } catch (error) {
            console.error("Error:", error.message);
            Swal.close();
            Swal.fire(t("Server Error"));
          }
        }
      });
  }
  async function deactivateTruck(id) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });
    swalWithBootstrapButtons
      .fire({
        title: t("Are you sure?"),
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: t("Yes"),
        cancelButtonText: "No",
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          const token = localStorage.getItem("token");
          const Newtoken = await tokenVerification(token);

          const url = `${GlobalURL}/api/dev/admin/deactivateTruck`;
          const headers = {
            "Content-Type": "application/json",
            lang_id: language,
            token: `${Newtoken}`,
            "ngrok-skip-browser-warning": "69420",
          };

          const requestData = {
            truck_id: id,
          };
          try {
            Swal.fire({
              title: "Loading...",
              allowOutsideClick: false,
              showConfirmButton: false, // Hide the "OK" button
              onBeforeOpen: () => {
                Swal.showLoading();
              },
            });
            const response = await fetch(url, {
              method: "POST", // Use the appropriate HTTP method (GET, POST, etc.)
              headers: headers,
              body: JSON.stringify(requestData),
            });

            const data = await response.json();

            if (data.status_code === 200) {
              Swal.close();
              Swal.fire(data.message);
            } else if (data.status_code === 404) {
              Swal.close();
              Swal.fire(data.message);
              return;
            } else if (data.status_code === 400) {
              Swal.close();
              Swal.fire(data.message);
              return;
            } else if (data.status_code === 401) {
              Swal.close();
              Swal.fire(data.message);
              return;
            } else {
              Swal.fire(t("Server Error"));
            }
            setUeload(!ueload);
            Swal.fire({ text: data.message, icon: "success" });
          } catch (error) {
            console.error("Error:", error.message);
            Swal.fire(t("Server Error"));
          }
        }
      });
  }
  const handleSuspendSwitch = (value, item) => {
    if (value) {
      unsuspendTruck(item.truck_id);
    } else {
      suspendTruck(item.truck_id);
    }
  };
  const handleStatusSwitch = (value, item) => {
    if (value) {
      activateTruck(item.truck_id);
    } else {
      deactivateTruck(item.truck_id);
    }
  };
  if (truckDetails === "" || truckDetails == null) {
    Swal.fire("Choose truck first");
    return;
  }
  const useFunction = async () => {
    const token = localStorage.getItem("token");
    const Newtoken = await tokenVerification(token);
    setShowPass(false);
    const requestData = {
      truck_id: idDel,
      password: password,
    };
    try {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        showConfirmButton: false, // Hide the "OK" button
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      const url = `${GlobalURL}/api/dev/admin/deleteTruck`;
      const headers = {
        "Content-Type": "application/json",
        lang_id: language,
        token: `${Newtoken}`,
        "ngrok-skip-browser-warning": "69420",
      };

      fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(requestData),
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
        })
        .then((data) => {
          if (data.status_code === 200) {
            Swal.close();
            Swal.fire(data.message);
          } else if (data.status_code === 404) {
            Swal.close();
            Swal.fire(data.message);
          } else if (data.status_code === 400) {
            Swal.close();
            Swal.fire(data.message);
          } else if (data.status_code === 401) {
            Swal.close();
            Swal.fire(data.message);
          } else {
            Swal.close();
            Swal.fire(t("Server Error"));
          }

          if (data.status_code !== 200) {
            Swal.close();
            Swal.fire("Error", data.message, "error");
            return;
          }

          setShowPass(false);
          Swal.fire(data.message);
          setUeload(!ueload);
        })
        .catch((error) => {
          console.error("There was a problem with the fetch operation:", error);
          Swal.fire(t("Server Error"));
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleSearchChange = (e) => {
    let data3 = originalData;
    setTruckData(originalData);
    const inputValue = e.target.value.toLowerCase();
    if (inputValue === "") {
      setTruckData(originalData);
      setSearchInput("");
      return;
    }
    // Filter the data based on all three fields
    const result = data3.filter((item) =>
      Object.values(item).some(
        (value) =>
          typeof value === "string" && value.toLowerCase().includes(inputValue)
      )
    );

    if (result.length === 0) {
      setTruckData([]);
    } else {
      setTruckData(originalData);
    }
    setSearchInput(inputValue);
    setTruckData(result);
  };
  async function getAllVendors() {
    const token = localStorage.getItem("token");
    const Newtoken = await tokenVerification(token);
    setLoading(true);

    const url = `${GlobalURL}/api/dev/admin/getAllVendors`;
    const headers = {
      "Content-Type": "application/json",
      lang_id: language,
      token: `${Newtoken}`,
      "ngrok-skip-browser-warning": "69420",
    };
    try {
      const response = await fetch(url, {
        method: "GET", // Use the appropriate HTTP method (GET, POST, etc.)
        headers: headers,
      });
      const responseData = await response.json();
      if (responseData.status_code === 200) {
        Swal.close();
        setLoading(false);
      }

      if (
        responseData.status_code === 404 ||
        responseData.status_code === 400 ||
        responseData.status_code === 401
      ) {
        Swal.close();
        Swal.fire(responseData.message);
        setLoading(false);
      } else if (responseData.status_code !== 200) {
        Swal.close();
        Swal.fire(t("Server Error"));
        setLoading(false);
      }
      const data = responseData.data.filter(
        (item) => item.vendor_id === truckDetails
      );
      setOriginalData(data[0].trucks);
      setTruckData(data[0].trucks);
      setLoading(false);
      // setUeload(!ueload);
    } catch (error) {
      Swal.close();
      setLoading(false);
      console.error("Error:", error.message);
    }
  }

  return (
    <React.Fragment>
      <Header />

      <div className="login-heading">
        <div className="back-heading-duo">
          {/* <MdOutlineArrowBack /><p>Back</p> */}
          <h1 style={{ marginTop: "80px" }}>
            {t("Vendor`s Name")}:-{" "}
            <span style={{ textTransform: "capitalize" }}>{vendor}</span>{" "}
          </h1>
          <h5 style={{ textTransform: "capitalize" }}>
            {t(`The table below depicts the truck details for Vendor Name `) +
              `${vendor}` +
              t(
                ` You can directly perform a set of actions based on the information provided in the table.`
              )}
          </h5>
        </div>
        <div className="table-div-vendors">
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="loading-spinner"></div>{" "}
              <p className="logging-heading">{t("Loading")}...</p>
            </div>
          ) : (
            <>
              <div className="search-back">
                <LuCircleChevronLeft
                  fill="none"
                  className="back-button"
                  onClick={() => navigate(-1)}
                />

                <div className="input-with-search">
                  <input
                    placeholder={t("search")}
                    value={searchInput}
                    onChange={(e) => {
                      handleSearchChange(e);
                    }}
                    className="searchInput"
                  />
                  <IoIosSearch />
                </div>
              </div>
              <div className="table-div-container">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th className="truckname-gap">{t("Truck Name")}</th>
                      <th>{t("Truck Name")}</th>
                      <th>{t("Username")}</th>
                      <th>{t("Delete")}</th>
                      <th>{t("Block")}</th>
                      <th>{t("Suspend")}</th>
                      <th>{t("Suspend Notice")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* truck details  */}
                    {truckData.map((truck, index) => (
                      <tr
                        key={index}
                        style={{ opacity: truck.is_deleted ? "0.5" : "1" }}
                      >
                        <td
                          style={{
                            padding: "7px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {truck.is_reported ? (
                            <>
                              <div>
                                <div
                                  data-tip="Tooltip content"
                                  data-for="example"
                                >
                                  <MdReport
                                    fill="red"
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content={t("Reported truck!")}
                                    style={{
                                      width: "30px",
                                      height: "34px",
                                      marginBottom: "30px",
                                    }}
                                  />
                                </div>

                                <ReactTooltip
                                  id="my-tooltip"
                                  className="tool-tip-reported"
                                />
                              </div>
                            </>
                          ) : (
                            ""
                          )}{" "}
                        </td>
                        <td className="Name-truck">{truck.truck_name}</td>
                        <td>{truck.vendor_username}</td>
                        <td>
                          {truck.is_deleted ? (
                            <Button
                              variant="contained"
                              disabled={true}
                              style={{
                                background: "#431119",
                                padding: "5px",
                                width: "50%",
                                cursor: "pointer",
                              }}
                            >
                              <p className="deletedMarker">{t("Deleted")}</p>
                            </Button>
                          ) : (
                            <>
                              <Button
                                sx={{ opacity: truck.is_primary ? "0.5" : "1" }}
                                variant="contained"
                                data-tooltip-id={
                                  truck.is_primary ? "my-tooltip" : " "
                                }
                                data-tooltip-content={t(
                                  "Primary truck cannot be deleted"
                                )}
                                onClick={() => {
                                  if (truck.is_primary) {
                                    return;
                                  }
                                  if (truck.is_deleted) {
                                    Swal.fire(
                                      t(
                                        "Warning: This action will permanently delete the truck and its associated details. Are you sure you want to proceed? This process cannot be undone."
                                      )
                                    );
                                  } else {
                                    deleteTruck(truck.truck_id);
                                    setidDel(truck.truck_id);
                                  }
                                }}
                                style={{
                                  background: "#431119",
                                  padding: "5px",
                                  width: "50%",
                                  cursor: "pointer",
                                }}
                              >
                                <RiDeleteBin2Line
                                  aria-disabled={true}
                                  fill="white"
                                />
                              </Button>
                              {truck.is_primary && (
                                <ReactTooltip
                                  id="my-tooltip"
                                  className="tool-tip-reported"
                                />
                              )}
                            </>
                          )}
                        </td>
                        <td>
                          <Form.Check // prettier-ignore
                            disabled={truck.is_deleted}
                            type="switch"
                            id="custom-switch"
                            onChange={() => {
                              handleStatusSwitch(truck.is_blocked, truck);
                            }}
                            checked={truck.is_blocked}
                          />
                        </td>
                        <td>
                          <Form.Check // prettier-ignore
                            disabled={truck.is_deleted}
                            type="switch"
                            id="custom-switch"
                            onChange={() => {
                              handleSuspendSwitch(truck.is_suspended, truck);
                            }}
                            checked={truck.is_suspended}
                          />
                        </td>
                        <td>
                          {truck?.suspend_msg ? (
                            <span>
                              {truck.suspend_msg.slice(0, 9) + "..."}
                              <BsArrowsFullscreen
                                onClick={() => {
                                  Swal.fire({
                                    text: `${truck.suspend_msg}`,
                                    title: t("Reason for suspention"),
                                  });
                                }}
                                style={{
                                  cursor: "pointer",
                                  marginLeft: "20px",
                                }}
                              />
                            </span>
                          ) : (
                            "-"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </>
          )}
        </div>

        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Body>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="loading-spinner"></div>{" "}
              <p className="logging-heading">{t("Loading")}</p>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={showPass}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
              {t("Password")}
            </Modal.Title>
            <label
              style={{ cursor: "pointer" }}
              onClick={() => {
                setShowPass(false);
              }}
            >
              X
            </label>
          </Modal.Header>
          <Modal.Body>
            <form autoComplete="off">
              <p>{t("Enter Profile Password")}</p>
              <input
                value={password}
                type="password"
                required
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={useFunction}>{t("Delete")}</Button>
          </Modal.Footer>
        </Modal>

        <Modal
          className="modal-reason"
          show={showReas}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
              {t("Justification")}
            </Modal.Title>
            <label
              onClick={() => {
                setShowReas(false);
              }}
            >
              X
            </label>
          </Modal.Header>
          <Modal.Body>
            <p>{t("Purpose Required For Suspention")}</p>
            <textarea
              value={reason}
              type="text"
              required
              onChange={(e) => {
                setReason(e.target.value);
              }}
              className="text-are-sus"
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => {
                suspendContinue();
              }}
            >
              {t("Done")}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  );
}

export default TruckDetails;
